
export default {
	name: 'BaseAnimation',
	props: {
		animationClass: {
			type: String,
			required: true,
		},
		duration: {
			'type': Number,
			'default': 1,
		},
		delay: {
			'type': Number,
			'default': 0,
		},
		infinite: {
			'type': Boolean,
			'default': false,
		},
	},
	elements: [],
	render() {
		return this.$slots.default;
	},
	mounted() {
		this.setup();
		this.runAnimation();
	},
	methods: {
		setup(components) {
			if (!components) {
				components = [...this.$slots.default];
			}

			if (!components.length) return;

			const component = components.shift();
			if (component && component.elm) {
				this.$options.elements.push(component.elm);
			}

			this.setup(components);
		},
		async runAnimation() {
			const animationClass = this.animationClass;
			this.$options.elements.forEach((elm) => {
				elm.style.animationDuration = `${this.duration}s`;
				elm.style.animationDelay = `${this.delay}s`;
				elm.classList.add(animationClass, 'animated');
			});
			await new Promise(resolve => setTimeout(resolve, (this.duration + this.delay) * 1000));
			this.$options.elements.forEach((elm) => {
				elm.classList.remove(animationClass, 'animated');
			});
			await new Promise(resolve => setTimeout(resolve, 0));
			if (this.infinite) this.runAnimation();
		},
	},
};
